/**
 * How much horizontal room the open agent rail takes from the page, in px.
 *
 * The brand grids that size their columns from window.innerWidth
 * (OriginalCardsView, PublishedCardsView) subtract this; the CSS push on
 * .tend-push-track is the same number (--tend-agent-w + the gap). The
 * rail dispatches AGENT_RESIZE_EVENT whenever it opens, closes or changes
 * width, so those grids recompute without a window resize.
 */
export const AGENT_RESIZE_EVENT = 'tend-agent-resize';
export const AGENT_REFRESH_EVENT = 'tend-agent-refresh';
export const AGENT_CARD_COL = 350;
export const AGENT_CARD_GAP = 20;
export const AGENT_MIN_COLS = 1;
export const AGENT_MAX_COLS = 4;

export const agentRailWidth = (cols: number): number =>
  cols * AGENT_CARD_COL + (cols - 1) * AGENT_CARD_GAP;

export function agentPushPx(): number {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0;
  if (window.innerWidth < 1024) return 0; // phones: the rail is a sheet over the page
  if (!document.body.classList.contains('tend-agent-open')) return 0;
  const raw = document.documentElement.style.getPropertyValue('--tend-agent-cols');
  const cols = Math.max(AGENT_MIN_COLS, Math.min(AGENT_MAX_COLS, parseInt(raw || '2', 10) || 2));
  return agentRailWidth(cols) + AGENT_CARD_GAP;
}

/** The most columns the rail may take without crossing the open profile sheet. */
export function agentMaxCols(sheetPushPx: number): number {
  if (typeof window === 'undefined') return AGENT_MAX_COLS;
  const avail = window.innerWidth - 48 - Math.max(0, sheetPushPx);
  return Math.max(AGENT_MIN_COLS, Math.min(AGENT_MAX_COLS, Math.floor((avail + AGENT_CARD_GAP) / (AGENT_CARD_COL + AGENT_CARD_GAP))));
}
